import clsx from 'clsx'
import styles from '../app/styles/SimpleHeader.module.sass'
import { Container } from './Container'
export function SimpleHeader(props: { headline: string; desc?: string; className?: string }) {
	return (
		<header className={clsx(styles.wrapper, props.className && styles[props.className])}>
			<Container>
				<div className={styles.inner}>
					<h1 className={styles.headline}>{props.headline}</h1>
					{props.desc && <article className={styles.description}>{props.desc}</article>}
				</div>
			</Container>
		</header>
	)
}
